import API from '../config/api';
import React, { useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import { useNavigate, Link } from 'react-router-dom';

import { authStyles } from './ForgotPasswordPage';
import DeliveryNavbar from '../components/DeliveryNavbar';

function DeliveryLoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const loginHandler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const { data } = await axios.post(
        `${API}/delivery/login`,
        { email, password }
      );

      localStorage.setItem('deliveryInfo', JSON.stringify(data));

      toast.success('Welcome back, partner!');

      navigate('/delivery');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DeliveryNavbar />

      <div className="auth-wrap">
        <Card className="border-0 shadow-lg auth-card">
          <Card.Body className="p-4 p-md-5">
            <div className="text-center mb-4">
              <div className="auth-icon">🛵</div>

              <h3 className="fw-bold mb-2">Delivery Partner Login</h3>

              <p className="text-muted mb-0">
                Sign in to view and deliver your assigned orders.
              </p>
            </div>

            <Form onSubmit={loginHandler}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Email Address</Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">✉️</span>

                  <Form.Control
                    type="email"
                    placeholder="you@example.com"
                    className="auth-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Password</Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">🔑</span>

                  <Form.Control
                    type={show ? 'text' : 'password'}
                    placeholder="Enter your password"
                    className="auth-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />

                  <button
                    type="button"
                    className="auth-eye"
                    onClick={() => setShow((s) => !s)}
                    aria-label={show ? 'Hide password' : 'Show password'}
                  >
                    {show ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </Form.Group>

              <Button
                type="submit"
                className="w-100 fw-bold auth-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Signing in...
                  </>
                ) : (
                  'Login'
                )}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <span className="text-muted">New delivery partner? </span>
              <Link to="/delivery/signup" className="auth-link">
                Register
              </Link>
            </div>

            <div className="text-center mt-2">
              <Link to="/" className="auth-link small">
                ← Back to Store
              </Link>
            </div>
          </Card.Body>
        </Card>
      </div>

      <style>{authStyles}</style>
    </>
  );
}

export default DeliveryLoginPage;
